import React from "react";
import { Outlet } from "react-router-dom";
import OuterHeader from "../../Components/OuterHeader/OuterHeader";

function Form(props) {
  return (
    <div>
      <OuterHeader />
      <Outlet />
    </div>
  );
}

export default Form;
